"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Głębokie kopiowanie
 * @param data date do skopiowania
 */
function deepCopy(data) {
    return JSON.parse(JSON.stringify(data));
}
exports.default = deepCopy;
//# sourceMappingURL=deepCopy.js.map